import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import categoryService from "../services/categoryService";

/**
 * Asynchronously fetches the list of categories from the server.
 * @param {{any}} data - The data to be passed to the server.
 * @returns A promise that resolves to the response data from the server.
 */
export const categoryListResponce = createAsyncThunk(
  "category/categoryListing",
  async (data) => {
    const res = await categoryService.getCategory(data);
    return res?.data;
  }
);

/**
 * Creates a new category using the provided data.
 * @param {{any}} data - The data for creating the category.
 * @returns A promise that resolves to the response from the server.
 */
export const createCategoryResponce = createAsyncThunk(
  "category/create",
  async (data) => {
    const res = await categoryService.createCategory(data);
    return res;
  }
);

/**
 * Updates a category by making an asynchronous request to the server.
 * @param {{any}} data - The data to be sent to the server for updating the category.
 * @returns A promise that resolves to the response from the server.
 */
export const updateCategoryResponce = createAsyncThunk(
  "category/update",
  async (data) => {
    const res = await categoryService.updateCategory(data);
    return res;
  }
);

/**
 * Deletes a category by making an asynchronous API call to the server.
 * @param {{number}} id - The ID of the category to delete.
 * @returns A promise that resolves to the response from the server.
 */
export const deleteCategoryResponce = createAsyncThunk(
  "category/delete",
  async (id) => {
    const res = await categoryService.deleteCategory(id);
    return res;
  }
);

const categorySlice = createSlice({
  name: "category",
  initialState: {
    categoryResponce: [],
    createCategoryResponce: [],
    createCategoryError: "",
    updateCategoryResponce: [],
    updateCategoryError: "",
    deleteCategoryResponce: [],
    deleteCategoryError: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(categoryListResponce.pending, (state) => {
        state.loading = true;
      })
      .addCase(categoryListResponce.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryResponce = action.payload;
      })
      .addCase(categoryListResponce.rejected, (state) => {
        state.loading = false;
      });
    // create

    builder
      .addCase(createCategoryResponce.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCategoryResponce.fulfilled, (state, action) => {
        state.loading = false;
        state.createCategoryResponce = action.payload;
      })
      .addCase(createCategoryResponce.rejected, (state, action) => {
        state.loading = false;
        state.createCategoryError = action?.error;
      });

    // update
    builder
      .addCase(updateCategoryResponce.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCategoryResponce.fulfilled, (state, action) => {
        state.loading = false;
        state.updateCategoryResponce = action.payload;
        state.categoryResponce = state.categoryResponce?.map((item) => {
          if (item?._id === action?.payload?.data?._id) {
            return { ...item, title: action?.payload?.data?.title };
          }
          return item;
        });
      })
      .addCase(updateCategoryResponce.rejected, (state, action) => {
        state.loading = false;
        state.updateCategoryError = action?.error;
      });

    // delete
    builder
      .addCase(deleteCategoryResponce.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCategoryResponce.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteCategoryResponce = action.payload;
        state.categoryResponce = state.categoryResponce?.filter(
          (item) => item?._id !== action?.payload?.data?._id
        );
      })
      .addCase(deleteCategoryResponce.rejected, (state, action) => {
        state.loading = false;
        state.deleteCategoryError = action?.error;
      });
  },
});

export default categorySlice.reducer;
